// extracted by mini-css-extract-plugin
export var styleContainer = "art_styles-module--styleContainer--exOUA";
export var imageRow = "art_styles-module--imageRow--Q73x+";
export var subStyle = "art_styles-module--subStyle--tpX34";
export var artInfoContainer = "art_styles-module--artInfoContainer--TWsWu";
export var artInfo = "art_styles-module--artInfo--n8x2i";